import { training } from '@/api/client';

export interface TrainingSyncOutcome {
  /** True when this poll found and recorded a new signature. */
  synced: boolean;
  completed_at: string | null;
  countersigned_at: string | null;
}

/**
 * DocuSeal flags a submitter complete a moment after its iframe shows the
 * "done" screen, and the webhook that mirrors that into Caspio can lag or
 * be lost. A single status check at dialog-close therefore misses a
 * signature that landed a second later and leaves the row on "Awaiting
 * countersignature". Poll the read-only status a few times; only when it
 * reports something new is the (write) finalize called — an open-and-close
 * with no signature still costs no write.
 */
export async function pollAndFinalizeTrainingSignature(
  certificationId: string,
  opts: { attempts?: number; intervalMs?: number } = {},
): Promise<TrainingSyncOutcome> {
  const attempts = opts.attempts ?? 5;
  const intervalMs = opts.intervalMs ?? 1500;
  let last: TrainingSyncOutcome = { synced: false, completed_at: null, countersigned_at: null };
  for (let i = 0; i < attempts; i += 1) {
    const status = await training.syncStatus(certificationId);
    last = { synced: false, completed_at: status.completed_at, countersigned_at: status.countersigned_at };
    if (status.any_newly_completed) {
      const r = await training.finalizeSync(certificationId);
      return { synced: r.synced, completed_at: r.completed_at, countersigned_at: r.countersigned_at };
    }
    if (status.countersigned_at) return last;
    if (i < attempts - 1) await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  return last;
}
